import { handleActions } from 'redux-actions';

import { actions } from '../actions/attachmentsPreviewModal';

const {
  attachmentsPreviewModalOpen,
  attachmentsPreviewModalClose,
  attachmentsPreviewModalNext,
  attachmentsPreviewModalPrevious,
} = actions;

export type AttachmentItem = {
  fileName: string;
  url: string;
};

export type AttachmentsPreviewModalState = {
  attachments: AttachmentItem[];
  currentIndex: number;
  fileName: string | null;
  url: string | null;
};

export const initialState: AttachmentsPreviewModalState = {
  attachments: [],
  currentIndex: 0,
  fileName: null,
  url: null,
};

const reducer = handleActions<AttachmentsPreviewModalState, any>(
  {
    [attachmentsPreviewModalOpen.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      const { fileName, url, attachments, currentIndex } = action.payload;

      return {
        ...state,
        url,
        fileName,
        attachments: attachments || [{ fileName, url }],
        currentIndex: currentIndex || 0,
      };
    },

    [attachmentsPreviewModalClose.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      return initialState;
    },

    [attachmentsPreviewModalNext.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      const nextIndex = (state.currentIndex + 1) % state.attachments.length;
      const nextAttachment = state.attachments[nextIndex];

      return {
        ...state,
        currentIndex: nextIndex,
        fileName: nextAttachment.fileName,
        url: nextAttachment.url,
      };
    },

    [attachmentsPreviewModalPrevious.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      const prevIndex =
        state.currentIndex === 0
          ? state.attachments.length - 1
          : state.currentIndex - 1;
      const prevAttachment = state.attachments[prevIndex];

      return {
        ...state,
        currentIndex: prevIndex,
        fileName: prevAttachment.fileName,
        url: prevAttachment.url,
      };
    },
  },
  initialState,
);

export default reducer;
